import Fetch from '../fetch'
import Storage from '../storage'
// 初始化
export function initConfig(_this) {
  // 用户信息
  let userInfo = Storage.queryItem('userInfo')
  if (userInfo === null) {
    return
  }
  // json 解析
  userInfo = JSON.parse(userInfo)
  let params = {
    openid: userInfo.openid,
    token: userInfo.token,
    url: window.location.href.split('#')[0]
  }
  Fetch.loadWxConfigure(params).then((resp) => {
    if (resp.code === 0) {
      // 配置微信
      wxConfigure(resp.data, _this)
    }
  }).catch((error) => {
    console.log(error)
  })
}

// 微信支付一元
export function payAYuan(option, completion) {
  // 支付
  wx.chooseWXPay({
    timestamp: option.timeStamp,
    nonceStr: option.nonceStr,
    package: option.package,
    signType: option.signType,
    paySign: option.paySign,
    success: function(res) {
      completion(true)
    },
    cancel: function(res) {
      completion(false)
    }
  })
}

// js sdk configure
function wxConfigure(params, _this) {
  // 配置
  wx.config({
    debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
    appId: params.appId, // 必填，公众号的唯一标识
    timestamp: params.timestamp, // 必填，生成签名的时间戳
    nonceStr: params.nonceStr, // 必填，生成签名的随机串
    signature: params.signature, // 必填，签名，见附录1
    jsApiList: [
      'chooseWXPay',
      'hideMenuItems'
    ] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
  })

  wx.error(function(res) {
    console.log(res)
  })

  wx.ready(function(res) {
    _this.$store.commit('updateWxReady', true)

    wx.hideMenuItems({
      menuList: [
        'menuItem:share:appMessage',
        'menuItem:share:timeline',
        'menuItem:share:qq',
        'menuItem:share:weiboApp',
        'menuItem:share:facebook',
        'menuItem:share:QZone',
        'menuItem:openWithQQBrowser',
        'menuItem:openWithSafari',
        'menuItem:share:email',
        'menuItem:editTag',
        'menuItem:delete',
        'menuItem:copyUrl',
        'menuItem:originPage',
        'menuItem:favorite'
      ] // 要隐藏的菜单项，只能隐藏“传播类”和“保护类”按钮，所有menu项见附录3
    })
  })
}



// WEBPACK FOOTER //
// ./src/common/wechat/wechat.js